import ContactGroupsAPI from 'dashboard/api/contactGroups';
import types from '../mutation-types';

const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getGroup: $state => contactId => $state.records[Number(contactId)] || null,
};

const setUpdating = (commit, value) =>
  commit(types.SET_CONTACT_GROUP_UI_FLAG, { isUpdating: value });

export const actions = {
  show: async ({ commit, state: $state }, { contactId, force = false }) => {
    if ($state.records[contactId] && !force) return;

    commit(types.SET_CONTACT_GROUP_UI_FLAG, { isFetching: true });
    try {
      const { data } = await ContactGroupsAPI.show(contactId);
      commit(types.SET_CONTACT_GROUP, { contactId, data });
    } catch (error) {
      commit(types.SET_CONTACT_GROUP, { contactId, data: null });
    } finally {
      commit(types.SET_CONTACT_GROUP_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, payload) => {
    setUpdating(commit, true);
    try {
      const { data } = await ContactGroupsAPI.create(payload);
      commit(types.SET_CONTACT_GROUP, { contactId: data.id, data });
      return data;
    } finally {
      setUpdating(commit, false);
    }
  },

  updateMetadata: async ({ commit }, { contactId, ...params }) => {
    setUpdating(commit, true);
    try {
      const { data } = await ContactGroupsAPI.updateMetadata(contactId, params);
      commit(types.SET_CONTACT_GROUP, { contactId, data });
      return data;
    } finally {
      setUpdating(commit, false);
    }
  },

  addMembers: async ({ commit }, { contactId, contactIds }) => {
    setUpdating(commit, true);
    try {
      const { data } = await ContactGroupsAPI.addMembers(contactId, contactIds);
      commit(types.SET_CONTACT_GROUP, { contactId, data });
      return data;
    } finally {
      setUpdating(commit, false);
    }
  },

  removeMember: async ({ commit, dispatch }, { contactId, memberId }) => {
    setUpdating(commit, true);
    try {
      await ContactGroupsAPI.removeMember(contactId, memberId);
      await dispatch('show', { contactId, force: true });
    } finally {
      setUpdating(commit, false);
    }
  },

  createInvite: async ({ commit, dispatch }, { contactId }) => {
    setUpdating(commit, true);
    try {
      const { data } = await ContactGroupsAPI.createInvite(contactId);
      await dispatch('show', { contactId, force: true });
      return data.invite_link;
    } finally {
      setUpdating(commit, false);
    }
  },

  revokeInvite: async ({ commit, dispatch }, { contactId }) => {
    setUpdating(commit, true);
    try {
      const { data } = await ContactGroupsAPI.revokeInvite(contactId);
      await dispatch('show', { contactId, force: true });
      return data.invite_link;
    } finally {
      setUpdating(commit, false);
    }
  },

  disband: async ({ commit }, { contactId }) => {
    setUpdating(commit, true);
    try {
      await ContactGroupsAPI.disband(contactId);
      commit(types.DELETE_CONTACT_GROUP, contactId);
    } finally {
      setUpdating(commit, false);
    }
  },
};

export const mutations = {
  [types.SET_CONTACT_GROUP_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_CONTACT_GROUP]($state, { contactId, data }) {
    $state.records = { ...$state.records, [contactId]: data };
  },
  [types.DELETE_CONTACT_GROUP]($state, contactId) {
    const { [contactId]: _removed, ...remainingRecords } = $state.records;
    $state.records = remainingRecords;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
